// extracted by mini-css-extract-plugin
var _1 = "SidebarSectionIcon-module__allTopicsIcon--d93Ct";
var _2 = "SidebarSectionIcon-module__myTopicsIcon--WAvx5";
var _3 = "SidebarSectionIcon-module__sectionIcon--YB54B";
export { _1 as "allTopicsIcon", _2 as "myTopicsIcon", _3 as "sectionIcon" }
